import React, { useContext, useState, useEffect } from "react"
import Layout from "../layout"
import Button from "../button/button"
import Logo from "../logo/logo"
import styled from "styled-components"
import { navigate } from "gatsby"
import {
  QuoteContext,
  KeyContext,
  QueryContext,
  ConfigurationContext,
  ProductContext,
  UserContext,
} from "../../state"
import { Spinner } from "@theme-ui/components"
import SEO from "../../components/seo"
const sanityClient = require("@sanity/client")
const client = sanityClient({
  projectId: "bxz6x68s",
  dataset: process.env.GATSBY_SANITY_STUDIO_API_DATASET,
  useCdn: false,
})

const Login = () => {
  const [, quoteDispatch] = useContext(QuoteContext)
  const [, keyDispatch] = useContext(KeyContext)
  const [, queryDispatch] = useContext(QueryContext)
  const [, configDispatch] = useContext(ConfigurationContext)
  const [, productDispatch] = useContext(ProductContext)
  const [userState, userDispatch] = useContext(UserContext)
  const [loading, setLoading] = useState(false)
  const [latestDocuments, setLatestDocuments] = useState(null)
  const [recommendedDocuments, setRecommendedDocuments] = useState(null)

  useEffect(() => {
    const userQuery = `*[_type == "user" && auth0Id == $id]`
    const userParams = { id: userState.auth0Id || "" }
    client.fetch(userQuery, userParams).then(user => {
      if (user.length > 0) userDispatch({ type: "init", user: user })
      if (user === []) userDispatch({ type: "reset" })
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!userState.isApproved) {
      return
    }

    const latestDocumentsQuery = `*[_type in ["configDoc", "productDoc", "miscDoc"]] | order(_updatedAt desc)[0...10]{title,slug{current}}`
    const recommendedDocumentsQuery = `*[_type == "recommendedDocs"][0]{docs[]->{title,slug{current}}}`
    client.fetch(latestDocumentsQuery).then(docs => {
      setLatestDocuments(docs)
    })
    client.fetch(recommendedDocumentsQuery).then(docs => {
      setRecommendedDocuments(docs)
    })
  }, [userState])

  function newConfiguration() {
    setLoading(true)
    quoteDispatch({ type: "reset" })
    productDispatch({ type: "reset" })
    queryDispatch({ type: "reset" })
    configDispatch({ type: "reset" })
    keyDispatch({ type: "reset" })
    navigate("/configurator/")
  }
  return (
    <Layout>
      <SEO title="Home" />
      <Center
        style={{ paddingTop: userState && userState.isApproved ? "0" : "50%" }}
      >
        {userState && userState.isApproved && (
          <Lists>
            {latestDocuments && latestDocuments.length > 0 && (
              <ListWrapper>
                <h3>Newest documents</h3>
                <List>
                  {latestDocuments.map((doc, i) => (
                    <ListItem key={i}>
                      <Link href={"/documents/" + doc?.slug?.current}>
                        {doc.title}
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </ListWrapper>
            )}
            {recommendedDocuments &&
              recommendedDocuments.docs &&
              recommendedDocuments.docs.length > 0 && (
                <ListWrapper>
                  <h3>Recommended documents</h3>
                  <List>
                    {recommendedDocuments.docs.map((rdoc, i) => (
                      <ListItem key={i}>
                        <Link href={"/documents/" + rdoc?.slug?.current}>
                          {rdoc.title}
                        </Link>
                      </ListItem>
                    ))}
                  </List>
                </ListWrapper>
              )}
          </Lists>
        )}
        <Logo />
        <Heading>
          {loading ? (
            <Spinner />
          ) : userState && userState.isApproved ? (
            <Button fullWidth dispatch={() => newConfiguration()}>
              SALES CONFIGURATOR
            </Button>
          ) : userState.length === 0 ? (
            ""
          ) : (
            <p>
              Your account is awaiting approval. Contact your sales
              representative.
            </p>
          )}
        </Heading>
      </Center>
    </Layout>
  )
}

export default Login

const Heading = styled.h1`
  text-align: center;
`

const Center = styled.div`
  .theme-dark & {
    color: white;
  }

  .theme-light & {
    color: black;
  }
`

const Lists = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  min-height: 400px;
  margin-bottom: 75px;
`

const ListWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 50%;
`

const List = styled.ol`
  margin: 0 20px;
`

const ListItem = styled.li`
  margin: 7px 0;
`
const Link = styled.a`
  .theme-dark & {
    color: white;
  }

  .theme-light & {
    color: black;
  }
`
